<template>
  <div>
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;筛选条件</span>
      </h4>
      <div class="selectColor">
        <div class="row">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-row>
                <el-col :span="4">
                  机构
                </el-col>
                <el-col :span="17">
                  <el-cascader placeholder="请输入" :options="options" filterable change-on-select v-model="manageCom"></el-cascader>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="4">
                  时间区间
                </el-col>
                <el-col :span="20">
                  <el-date-picker
                    type="daterange"
                    align="right"
                    unlink-panels
                    :editable="false"
                    :clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    @change="dateChange"
                    v-model="dateStart"
                    :default-value="dateStart"
                    class="maxWidth"
                    :picker-options="pickerOptions2"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="7">汇总类型</el-col>
                <el-col :span="17">
                  <el-select v-model="req.summaryType" placeholder="请选择" @change="summaryTypeChange">
                    <el-option label="全国" :value="0" v-if="show">全国</el-option>
                    <el-option label="分公司" :value="1">分公司</el-option>
                    <el-option label="机构" :value="2">机构</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <!-- <el-col :span="6">
              <el-row>
                <el-col :span="6">考试类型</el-col>
                <el-col :span="18">
                  <el-select v-model="req.examType" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="新人" :value="0">新人</el-option>
                    <el-option label="地区" :value="1">地区</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col> -->
          </el-row>
        </div>
      </div>
      <div class="row">
        <div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-row>
                <el-col :span="8">险种代码</el-col>
                <el-col :span="16">
                  <el-select filterable multiple v-model="riskCode" placeholder="请选择">
                    <el-option v-for="item in riskList" :key="item.value" :label="item.riskCode" :value="item.riskCode"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="7">险种名称</el-col>
                <el-col :span="17">
                  <el-input class="input" v-model="riskName" placeholder="请输入险种名称"></el-input> 
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="7">险种类别</el-col>
                <el-col :span="17">
                  <el-select v-model="riskType" placeholder="请选择" >
                      <el-option label="全部" :value="null">全部</el-option>
                      <el-option label="普通产品销售资格" :value="'12'">普通产品销售资格</el-option>
                      <el-option label="分红产品销售资格" :value="'13'">分红产品销售资格</el-option>
                      <el-option label="特许产品销售资格" :value="'23'">特许产品销售资格</el-option>
                      <el-option label="专用产品销售资格" :value="'22'">专用产品销售资格</el-option>
                      <el-option label="标准产品销售资格" :value="'122'">标准产品销售资格</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="7">主险/附险</el-col>
                <el-col :span="17">
                  <el-select v-model="isMaster" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="主险" value="M">主险</el-option>
                    <el-option label="附险" value="A">附险</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <!-- <el-col :span="2" :offset="20">
              <el-button type="primary" @click="reset()">重置</el-button>
            </el-col>
            <el-col :span="2" :offset="0">
              <el-button type="primary" @click="search()">查询</el-button>
            </el-col> -->
          </el-row>
          <div class="btnh">
            <div class="flr">
              <el-button type="primary" @click="reset()">重置</el-button>
              <el-button type="primary" @click="search()">查询</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <h4 class="title1"><span>&nbsp;&nbsp;查询结果</span> <el-button class="right" type="primary" @click="exportResult">导出</el-button></h4>
      <div>
        <el-table :data="result" style="width: 100%">
          <el-table-column type="index" label="序号" align="center"> </el-table-column>
          <el-table-column prop="t2Name" label="T2名称" width="100" align="center"> </el-table-column>
          <el-table-column prop="t2Code" label="T2代码" width="100" align="center"> </el-table-column>
          <el-table-column prop="t3Name" label="T3名称" width="100" align="center" v-if="T3"> </el-table-column>
          <el-table-column prop="t3Code" label="T3代码" width="100" align="center" v-if="T3"> </el-table-column>
          <el-table-column prop="t4Name" label="T4名称" width="100" align="center" v-if="T4"> </el-table-column>
          <el-table-column prop="t4Code" label="T4代码" width="100" align="center" v-if="T4"> </el-table-column>
          <el-table-column prop="riskCode" label="险种代码" width="100" align="center" > </el-table-column>
          <el-table-column prop="riskName" label="险种名称" width="100" align="center" > </el-table-column>
          <!-- <el-table-column prop="riskType"  :formatter="formatterRiskType" label="险种类别" width="100" align="center" > </el-table-column> -->
           <el-table-column prop="riskType" label="险种类别" width="100" align="center" > </el-table-column>
          <el-table-column :formatter="isFormatterMaster" prop="isMaster" label="主险/附险" width="100" align="center"> </el-table-column>
          <el-table-column prop="examPeople" label="参考人数" width="100" align="center"> </el-table-column>
          <el-table-column prop="passPeople" label="通过人数" width="100" align="center"> </el-table-column>
          <el-table-column prop="examNum" label="参考人次" width="100" align="center"> </el-table-column>
          <el-table-column prop="passNum" label="通过人次" width="100" align="center"> </el-table-column>
          <el-table-column prop="phoneNum" label="参考手机终端数" width="150" align="center"> </el-table-column>
          <el-table-column prop="padNum" label="参考PAD终端数" width="150" align="center"> </el-table-column>
          <!-- <el-table-column prop="pcNum" label="参考PC终端数" width="150" align="center"> </el-table-column> -->
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          class="my-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="req.startIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total,sizes, prev, pager, next, jumper"
          prev-click
          next-click
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  data() {
    return {
      cityList:[],
      manageComList:null,
      riskList:[],
      riskCode:null,
      isMaster:null,
      riskName:null,
      riskType:null,
      dateStart: '',
      options: [{}],
      manageCom: [],
      manageCom1: [],
      // startDate:'',
      // endDate:'',
      req: {
        manageCom: 'HO',
        level:'',
        riskCodes:null,
        riskName:null,
        riskType:null,
        isMaster:null,
        startDate: '',
        endDate: '',
        startIndex: 1,
        pageSize: 10,
        summaryType: 0
      },
      T3: false,
      T4: false,
      total: 0,
      result: [],
      loadUrl: '',
      show:true,
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    reset() {
      // 重置
        // manageCom: '2',
        // level:'2',
        // startIndex: 1,
        // pageSize: 5,
        // summaryType: 0,
        // startDate: '',
        // endDate: '',
        // riskCodes:this.riskCode,
        // riskName:this.riskName?this.riskName:null,
        // riskType:this.riskType?this.riskType:null,
        // isMaster:this.isMaster?this.isMaster:null,
      this.manageCom = this.manageCom1;
      this.initDate();
      this.req.manageCom = this.manageCom;
      this.req.examType = null;
      this.req.startIndex = 1;
      this.req.pageSize = 5;
      this.req.summaryType = this.show?0:1;
      this.riskName = null
      this.isMaster = null
      this.riskType = null
      this.riskCode = []
      this.T3= this.show?false:true
      this.T4 =false
      // this.riskCode = null
      // console.log(this.riskCode,'riskCode')
      // console.log(this.riskCodes,'riskCodes')
      // this.riskCodes = null
      // this.getRiskExamSummary();
    },
    summaryTypeChange(value) {
      if (value === 0) {
        this.T3 = false;
        this.T4 = false;
      }
      if (value === 1) {
        this.T3 = true;
        this.T4 = false;
      }
      if (value === 2) {
        this.T3 = true;
        this.T4 = true;
      }
    },
    formatterRiskType(row){
        if(row.riskType == 12){
          return '普通产品销售资格'
        }else if(row.riskType==13){
          return '分红产品销售资格'
        }else if(row.riskType ==23){
          return '特许产品销售资格'
        }else if(row.riskType == 22){
          return '专用产品销售资格'
        }else if(row.riskType == 122){
          return '标准产品销售资格'
        }
    },
    initManageCom() {
      let that = this;
      api.post(url.initAllManageCom, {}, function(res) {
        that.options = JSON.stringify(res.data)
          .trim()
          .replace(/"children":\[\],/g, '');
        // console.log(that.options);
        that.options = JSON.parse(that.options);
        that.manageCom = that.options[0].value;
        that.manageCom1 = that.options[0].value;
        that.req.manageCom = that.options[0].value;
        if(!sessionStorage.getItem('show')){
          that.show=false
          that.req.summaryType=1
          that.T3 = true;
          that.T4 = false;
        }
        that.getRiskExamSummary();
        // that.options.push({label: '全国', value: 'HO'})
      });
    },
    //查询
    search(){
      if(this.manageCom instanceof Array){
        this.manageCom.forEach((item,index)=>{
          this.manageComList = item
        })
      }
      this.req = {
        manageCom: this.manageComList?this.manageComList:this.manageCom,
        level:'',
        startIndex: 1,
        pageSize: 10,
        summaryType: this.req.summaryType,
        startDate: this.req.startDate,
        endDate: this.req.endDate,
        riskCodes:this.riskCode,
        riskName:this.riskName?this.riskName:null,
        riskType:this.riskType?this.riskType:null,
        isMaster:this.isMaster?this.isMaster:null,
      }
      // console.log(this.req.manageCom,'manageCOm')
      if(!this.req.riskCodes.length){
        this.req.riskCodes = null
      }else {
        this.req.riskCodes = []
        this.req.riskCodes = this.riskCode
      }  
      this.getRiskExamSummary()
      this.manageComList = 'HO'
      // this.initDate()   
    },
    //获取汇总考试列表
    getRiskExamSummary() {
      let that = this;
      api.post(url.getRiskExamSummary, this.req, function(res) {
        if (res.result.isSuccess) {
          that.total = res.data.total;
          that.result = res.data.data;
        }else{
          that.$message({
            type:'error',
            message:res.result.error
          })
        }
      });
    },
    //获取类型险种列表
    initRiskTypes(){
      let that = this
      api.post(url.initRiskTypes, {}, function(res) {
        if (res.result.isSuccess) {
          that.riskList = res.data 
        } else {
          that.$message({
            
          });
        }
      });
    },
    isFormatterMaster(row){
      if(row.isMaster === 'M'){
        row.isMaster = '主险'
      }else if(row.isMaster === 'A'){
        row.isMaster = '附险'
      }
      return row.isMaster
    },
    // --------分页
    handleSizeChange(value) {
      this.req.pageSize = value;
      this.req.startIndex = 1;
      this.getRiskExamSummary();
    },
    handleCurrentChange(value) {
      this.req.startIndex = value;
      this.getRiskExamSummary();
    },
    dateChange(value) {
      let startDate = new Date(value[0]);
      let endDate = new Date(value[1]);
      this.req.startDate = startDate.getTime();
      this.req.endDate = endDate.getTime();
    },
    initDate() {
      let current = new Date();
      let startOfMonth = this.moment(current)
        .startOf('month')
        .format('YYYY/MM/DD');
      let endOfMonth = this.moment(current)
        .endOf('month')
        .format('YYYY/MM/DD');
      this.req.startDate = new Date(startOfMonth).getTime();
      this.req.endDate = new Date(endOfMonth).getTime();
      this.dateStart = [new Date(startOfMonth), new Date(endOfMonth)];
    },
    exportResult() {
      let that = this;
      // console.log(this.req,'req')
      api.post(url.exportRiskExamSummary, this.req, function(res) {
        if (res.result.isSuccess) {
          that.loadUrl = res.data;
        } else {
          console.log('失败');
        }
      });
    }
  },
  watch: {
    manageCom(newValue, oldValue) {
      if (newValue.length === 1 && oldValue.length != 0) {
        this.req.manageCom = newValue[0];
      }
      if (newValue.length === 2 && oldValue.length != 0) {
        this.req.manageCom = newValue[1];
      }
      if (newValue.length === 3 && oldValue.length != 0) {
        this.req.manageCom = newValue[2];
      }
      if (newValue.length === 4 && oldValue.length != 0) {
        this.req.manageCom = newValue[3];
      }
    },
    loadUrl(newValue, oldValue) {
      // console.log(newValue);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = newValue;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  mounted() {
    this.initDate();
    this.initManageCom();
    // this.getRiskExamSummary()
    this.initRiskTypes();
  },
};
</script>

<style scoped>
.title1 {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}
.selectColor {
  padding-bottom: 1px;
}
.row {
  margin-top: 20px;
  padding-left: 20px;
  line-height: 50px;
}
.footer {
  padding: 10px 0 30px 0;
}
.right {
  margin: 5px 22px 0 0;
  float: right;
}
.my-pagination {
  float: right;
}
.maxWidth {
  width: 100%;
}
.btnh{
  height: 50px;
}
.flr{
  margin-right: 22px;
  float:right;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/examRiskExamTotal.vue